import type { TOC } from '@ember/component/template-only';
import safeFormatDate from '../../../helpers/safe-format-date.ts';

export interface ItemDetailsSignature {
  Args: {
    details?: string;
    date?: string;
  };
  Element: HTMLDivElement;
}

const ItemDetails: TOC<ItemDetailsSignature> = <template>
  {{#if @details}}
    <div
      class="flex w-full ml-2 mb-2 items-center justify-between text-tio-gray-400 dark:text-gray-400"
      ...attributes
    >
      <p class="py-0.5 text-sm leading-5 text-tio-gray-700 dark:text-gray-300 mr-2 flex-wrap">
        {{@details}}
      </p>
      <div
        class="flex flex-wrap justify-end md:flex-nowrap md:whitespace-nowrap order-1 md:order-none md:divide-x md:divide-gray-400 dark:md:divide-gray-500"
      >
        <time
          datetime={{@date}}
          class="py-0.5 px-2 text-xs leading-5 text-tio-gray-400 dark:text-gray-400"
        >
          {{safeFormatDate @date hour="numeric" minute="2-digit" timeZoneName="short"}}
        </time>
        <time
          datetime={{@date}}
          class="py-0.5 px-2 text-sm leading-5 text-tio-gray-600 dark:text-gray-400"
        >
          {{safeFormatDate @date month="short" day="2-digit" year="numeric"}}
        </time>
      </div>
    </div>
  {{/if}}
</template>;

export default ItemDetails;

/**
 * Example usage:
 *
 *

 get timeline() {
    return [
      {
        details: 'Repayment of $30.00',
        date: '2020-09-20',
        icon: 'UserIcon',
        iconBackground: 'bg-gray-400',
      },
      {
        details: 'Repayment request of $60.00 from Mariah Carey',
        date: '2020-09-22',
        icon: 'HandThumbUpIcon',
        iconBackground: 'bg-blue-500',
      },
      {
        approverName: 'Janis Ian - Approver',
        approverComment: 'Called client, they reassured me the invoice would be paid by the 25th.',
        details: 'Payment request of $199.50 made to Bank Account',
        date: '2020-09-28',
        icon: 'CheckIcon',
        iconBackground: 'bg-green-500',
      },
      {
        details: 'Application approved by Chappell Roan', // Corrected line
        date: '2020-09-30',
        icon: 'Document',
        iconBackground: 'bg-blue-500',
      },
      {
        details: 'Application Submitted for approval by Troye Sivan',
        date: '2020-10-04',
        icon: 'CurrencyDollar',
        iconBackground: 'bg-green-500',
      },
      {
        details: 'Not much to see here',
        date: '2024-10-16',
      },
      {
        details: 'Not much to see there either',
        date: '2024-10-16',
      },
    ];
  }

          <Feed @feed={{this.timeline}}>
            <:record as |item|>
              <ItemDetails @details={{item.details}} @date={{item.date}} />
            </:record>
            <:comment as |item|>
              <ItemComment
                @approverComment={{item.approverComment}}
                @approverName={{item.approverName}}
              />
            </:comment>
          </Feed>

          */
